import React, {useEffect} from 'react';
import Alert from "react-bootstrap/Alert";
import Pages from "../components/layout/Pages";
import {concepts} from "fearless-common";
import {Button} from "fearless-common-ui";
import Header from "../components/Header";
import {routes} from "../utils";
import Description from "../components/Description";
import StandardIcons from "../components/layout/StandardIcons";
import {externalLinks} from "../utils/routes";
import {useSearchParams} from "react-router-dom";


// Open Photo51 on desktop
export function openPhoto51DesktopApplication() {
    window.location.href = externalLinks.photo51desktop;
}


export const OpenPhoto51SearchFlags = {
    SHARE_REQUEST_ACCESS_LINK: 'share-request-access-link'
}


export default function OpenPhoto51() {
    useEffect(() => {
        // delay opening the desktop application just a little, because it breaks the E2E tests.
        // With a small timeout, the E2E test can quickly move on.
        setTimeout(() => openPhoto51DesktopApplication(), 500);
    }, []);

    const [searchParams] = useSearchParams();

    return (
        <Pages.Centred width="xs" className="text-center">
            <Header component="h1" className="gradient-color mb-5">Opening {concepts.Photo51}</Header>
            {searchParams.has(OpenPhoto51SearchFlags.SHARE_REQUEST_ACCESS_LINK) && (
                <Alert variant="success">Your files are in your {concepts.Photo51} share requests inbox.</Alert>
            )}
            <Description>
                If the application does not open by itself, please use the button below.
            </Description>

            <a href={externalLinks.photo51desktop}>
                <Button>Open {concepts.Photo51} desktop</Button>
            </a>
            <hr className="my-5" />
            <Description>
                Or open {concepts.Photo51} in cloud.
            </Description>
            <a href={routes.photo51Cloud}>
                <Button variant="light" className="text-white" icon={<StandardIcons.Cloud width={20} />}>
                    Open {concepts.Photo51} cloud
                </Button>
            </a>
        </Pages.Centred>
    );
}
